import styled from 'styled-components';

export const Base = styled.h2`
	flex: 1;
	min-width: 0;
	margin: 0;
	height: var(--navbar-height);
	line-height: var(--navbar-height);
	user-select: none;
	font-size: 14px;
	font-family: 'Inter', sans-serif;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	margin-left: 6px;
`;
